import styled from 'styled-components';

import useTranslation from 'shared/hooks/useTranslation';

import AnimatedNumber from 'modules/home/v2/components/AnimatedNumber';
import BlurElement from './BlurElement';
import { DesktopBlur, MobileBlur, Wrapper } from './styled';

function Statistics(): JSX.Element {
  const { t } = useTranslation('ourTeamPage');

  return (
    <StyledWrapper maxWidth>
      <DesktopBlur>
        <BlurElement speed={0.4} size={500} direction="right" position={{ x: 0, y: 0 }} />
        <BlurElement speed={0.4} size={400} direction="right" position={{ x: 0, y: -200 }} />
        <BlurElement speed={0.4} size={600} position={{ x: 0, y: -500 }} />
      </DesktopBlur>
      <MobileBlur>
        <BlurElement speed={0.2} size={300} position={{ x: 0, y: -150 }} />
        <BlurElement speed={0.2} size={300} direction="right" position={{ x: 0, y: -450 }} />
      </MobileBlur>
      <Header>
        <BigHeader>
          {t('ourExperts')} -<br />
          {t('yourSuccesses')}🔥
        </BigHeader>
        <SmallHeader>{t('trustMateSince2018')}</SmallHeader>
      </Header>
      <StatisticGrid>
        <Statistic>
          <Number>
            <AnimatedNumber numberValue={40} suffix="+" />
          </Number>
          <Text>{t('trustMateExperts')}</Text>
        </Statistic>
        <Statistic>
          <Number>
            <AnimatedNumber numberValue={13} suffix="K+" />
          </Number>
          <Text>{t('satisfiedCustomers')}</Text>
        </Statistic>
        <Statistic>
          <Number>
            <AnimatedNumber numberValue={15} alternativeRef="15mln" suffix="MLN+" />
          </Number>
          <Text>{t('collectedReviews')}</Text>
        </Statistic>
      </StatisticGrid>
    </StyledWrapper>
  );
}

const StyledWrapper = styled(Wrapper)`
  @media ${({ theme }) => theme.DEVICE.MD} {
    margin-top: 20rem;
  }
`;

const Header = styled.header`
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
  color: #fff;

  @media ${({ theme }) => theme.DEVICE.MD} {
    gap: 10rem;
    grid-template-columns: 1fr 2fr;
  }
`;

const BigHeader = styled.h2`
  font-size: 2.4rem;
  line-height: 106%;
  letter-spacing: 1px;

  @media ${({ theme }) => theme.DEVICE.MD} {
    font-size: 4.8rem;
  }
`;

const SmallHeader = styled.h3`
  font-size: 1.6rem;
  font-weight: 400;
  line-height: 126%;

  @media ${({ theme }) => theme.DEVICE.MD} {
    font-size: 2.6rem;
  }
`;

const StatisticGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4rem;
  margin-top: 7rem;

  @media ${({ theme }) => theme.DEVICE.MD} {
    display: grid;
    margin: 10rem;
    grid-template:
      'a b' 1fr
      'c c' 1fr / 1fr 1fr;
    gap: 6.4rem;

    > div:nth-of-type(1) {
      grid-area: a;
    }

    > div:nth-of-type(2) {
      grid-area: b;
    }

    > div:nth-of-type(3) {
      grid-area: c;
    }
  }
`;

const Statistic = styled.div`
  color: white;
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  align-items: center;
  justify-content: center;
`;

const Number = styled.div`
  background: linear-gradient(93deg, #ffa727 26.7%, #fc8103 98.5%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-transform: uppercase;
  font-size: 6.4rem;
  font-weight: 600;
  line-height: 128%;

  @media ${({ theme }) => theme.DEVICE.MD} {
    font-size: 11.2rem;
  }
`;

const Text = styled.div`
  text-transform: uppercase;
  font-size: 1.6rem;

  @media ${({ theme }) => theme.DEVICE.MD} {
    font-size: 2rem;
  }
`;

export default Statistics;
